export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 100 },
  { key: '3', headerName: 'Definitions', field: 'def_title', hide: false, width: 350 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 200 },
];
